// extracted by mini-css-extract-plugin
export default {"chip":"ApplicationsFilter_chip__rQGBV","selected":"ApplicationsFilter_selected__iB+X-"};